export default "__VITE_ASSET__soj3f1km__"